var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mt-1 mr-2 pt-2 mt-5 text-none",attrs:{"elevation":"2","x-large":"","color":"green lighten-3"},on:{"click":_vm.discardChanges}},Object.assign({}, tooltip)),[_vm._v(" Откатить изменения ")])]}}])},[_c('span',[_vm._v("Вернуться к настройкам шаблона")])])}
var staticRenderFns = []

export { render, staticRenderFns }